import React, { useEffect, useState } from 'react'
import TableContent from '../../../components/TableContent'
import AgentRecruiterDetails from './RecruiterDetails'

const url = 'agents/recruiters'
const item = 'Recruiter'
const items = 'Recruiters'

const AgentRecruiter = () => {
  const [agent, setAgent] = useState(null)
  const [refreshData, setRefreshData] = useState(null)
  const [key, setKey] = useState(0)

  const onAgentSelected = agent => {
    setAgent(agent)
    setKey(prevKey => prevKey + 1) // Change key to force re-render
  }

  const onRefreshData = () => {
    setRefreshData(prev => !prev)
    setKey(prevKey => prevKey + 1) // Change key to force re-render
  }

  return (
    <>
      <TableContent
        url={url}
        type={'agent-recruiter'}
        item={item}
        items={items}
        onRowSelect={onAgentSelected}
        refreshData={refreshData}
        onRefreshData={onRefreshData}
      />
      {agent && <AgentRecruiterDetails key={key} agent={agent} refreshData={setRefreshData} />}
    </>
  )
}

export default AgentRecruiter
